export const SALESDOCUMENT_CREATE_REQUEST = 'SALESDOCUMENT_CREATE_REQUEST';
export const SALESDOCUMENT_CREATE_SUCCESS = 'SALESDOCUMENT_CREATE_SUCCESS';
export const SALESDOCUMENT_CREATE_FAIL = 'SALESDOCUMENT_CREATE_FAIL';
export const SALESDOCUMENT_CREATE_RESET = 'SALESDOCUMENT_CREATE_RESET';

export const SALESDOCUMENT_LIST_REQUEST = 'SALESDOCUMENT_LIST_REQUEST';
export const SALESDOCUMENT_LIST_SUCCESS = 'SALESDOCUMENT_LIST_SUCCESS';
export const SALESDOCUMENT_LIST_FAIL = 'SALESDOCUMENT_LIST_FAIL';

export const SALESDOCUMENT_DETAILS_REQUEST = 'SALESDOCUMENT_DETAILS_REQUEST';
export const SALESDOCUMENT_DETAILS_SUCCESS = 'SALESDOCUMENT_DETAILS_SUCCESS';
export const SALESDOCUMENT_DETAILS_FAIL = 'SALESDOCUMENT_DETAILS_FAIL';

export const SALESDOCUMENT_UPDATE_REQUEST = 'SALESDOCUMENT_UPDATE_REQUEST';
export const SALESDOCUMENT_UPDATE_SUCCESS = 'SALESDOCUMENT_UPDATE_SUCCESS';
export const SALESDOCUMENT_UPDATE_FAIL = 'SALESDOCUMENT_UPDATE_FAIL';

export const SALESDOCUMENT_DELETE_REQUEST = 'SALESDOCUMENT_DELETE_REQUEST';
export const SALESDOCUMENT_DELETE_SUCCESS = 'SALESDOCUMENT_DELETE_SUCCESS';
export const SALESDOCUMENT_DELETE_FAIL = 'SALESDOCUMENT_DELETE_FAIL';

export const SALESDOCUMENT_DOWNLOAD_REQUEST = 'SALESDOCUMENT_DOWNLOAD_REQUEST';
export const SALESDOCUMENT_DOWNLOAD_SUCCESS = 'SALESDOCUMENT_DOWNLOAD_SUCCESS';
export const SALESDOCUMENT_DOWNLOAD_FAIL = 'SALESDOCUMENT_DOWNLOAD_FAIL';